var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.76s.027-.067.027-.107v-1.44c0-1.413-1.134-2.56-2.534-2.56h-2.92c-1.4 0-2.533 1.147-2.533 2.56v1.44s.013.067.027.107H1a.66.66 0 00-.667.667.66.66 0 00.667.666h.653v17.04c0 2.307 1.787 4.2 3.987 4.2h10.653c2.2 0 3.987-1.88 3.987-4.2V6.093h.733a.66.66 0 00.667-.666.66.66 0 00-.667-.667H15zm-6.627-.107v-1.44c0-.68.534-1.226 1.2-1.226h2.92c.667 0 1.2.546 1.2 1.226v1.44s.014.067.027.107H8.36s.027-.067.027-.107h-.014zm10.574 18.48c0 1.587-1.187 2.867-2.654 2.867H5.64c-1.467 0-2.653-1.293-2.653-2.867V6.093h15.96v17.04z",
    fill: "#D4231A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72 23.333a.66.66 0 00.667-.666V9.347a.66.66 0 00-.667-.667.66.66 0 00-.667.667v13.32a.66.66 0 00.667.666zM14.347 23.387a.66.66 0 00.666-.667V9.4a.66.66 0 00-.666-.667.66.66 0 00-.667.667v13.32a.66.66 0 00.667.667z",
    fill: "#D4231A"
  })));
}
export default SvgTrash;